var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFerienwohnung = function SvgFerienwohnung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Ferienwohnung")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ferienwohnung",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-architecture-door@24x24",
    transform: "translate(41.000000, 38.000000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1333333,0.5 L55.8666667,0.5 C57.5962667,0.5 59,1.91368889 59,3.65555556 L59,71.5 L12,71.5 L12,3.65555556 C12,1.91368889 13.4037333,0.5 15.1333333,0.5 Z",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 72,
    x2: 68,
    y2: 72,
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 47,
    cy: 37.5,
    r: 4
  })))));
};
export default SvgFerienwohnung;